import React, { useContext } from 'react'
import { Table } from 'components/common'
import { useTranslation } from 'react-i18next'
import { useHistory } from 'react-router-dom'
import { UserContext } from "../../stores/UserStore"
import { FaArrowRight } from 'react-icons/fa'
import { TubularContext } from 'stores/TubularStore'
import moment from 'moment'
import styled from 'styled-components'

const DetailArrow = styled(FaArrowRight)`
  color: #777;
  cursor: pointer;
  transition: 0.5s;
   
   &:hover{
    color: #aaa;
   }
`
const ReservationCard = ({ data }) => {
    const history = useHistory()
    const { registryLogOld, registryLog } = useContext(UserContext)
    const { setValueData } = useContext(TubularContext)

    const goTo = (value) => {
        registryLogOld('got_to_reservation', '/tlh/home')
        registryLog('home', 'navigation', 'got_to_reservation')
        console.log(value)
        setValueData(value)
        history.push("/reservation/" + value)
    }
    const { t } = useTranslation()

    const columns = [
        {
            Header: t('tlh.home.tabs.reservation').toUpperCase(),
            accessor: (row) => row.reservation,
            id: 'sot',
        },
        {
            Header: t("tlh.search.customer"),
            accessor: (row) => row.customerId,
            id: 'contract',
        },
        {
            Header: t('tlh.search.date'),
            accessor: (row) => moment(row.date).format("DD/MM/YYYY"),
            id: 'date',
        },
        {
            Header: 'See piece',
            accessor: (row) => {
                return (
                    <DetailArrow size="1rem" onClick={() => goTo(row.reservation)} />
                )
            },
        }
    ]

    return (
        <Table width="100%" columns={columns} data={data} sortable paginated style={{ whiteSpace: 'nowrap', with: "100%" }}></Table>
    )
}

export default ReservationCard
